import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService, SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';
import { QuestionTagHttpModel, UserTagHttpModel } from './user-tag-http.model';

@Injectable({
  providedIn: 'root',
})
export class QuestionTagHttpService extends SupabaseBaseHttpService<'user_tags', 'learning'> {
  constructor(supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'learning' as const;
  readonly tableName = 'user_tags' as const;

  getAll(userId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select('*')
        .eq('user_id', userId)
        .order('is_system', { ascending: false })
        .order('name', { ascending: true })
        .throwOnError()
        .then((res) => res.data as UserTagHttpModel[]),
    );
  }

  assignToQuestion(questionId: number, tagId: string, userId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from('question_tags')
        .insert({
          question_id: questionId,
          tag_id: tagId,
          user_id: userId,
        })
        .select('*')
        .single()
        .throwOnError()
        .then((res) => res.data as QuestionTagHttpModel),
    );
  }

  removeTagFromQuestion(questionId: number, tagId: string, userId: string): Observable<void> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from('question_tags')
        .delete()
        .eq('question_id', questionId)
        .eq('tag_id', tagId)
        .eq('user_id', userId)
        .throwOnError()
        .then(() => undefined),
    );
  }
}
